import axios from 'axios';
import { API_URL } from 'configs'

export const AI_COMPARISON_FIELDS_REQUEST = 'AI_COMPARISON_FIELDS_REQUEST'
export const AI_COMPARISON_FIELDS_SUCCESS = 'AI_COMPARISON_FIELDS_SUCCESS'
export const AI_COMPARISON_FIELDS_VALIDATION_ERROR = 'AI_COMPARISON_FIELDS_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_AI_COMPARISON_FIELDS_FEILD_VALIDATION_ERROR = "HIDE_AI_COMPARISON_FIELDS_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_AI_COMPARISON_FIELDS_LIST = 'REDIRECT_TO_AI_COMPARISON_FIELDS_LIST'
export const AI_COMPARISON_FIELDS_GET_SUCCESS = 'AI_COMPARISON_FIELDS_GET_SUCCESS'
export const AI_COMPARISON_FIELDS_SERVER_SUCCESS = 'AI_COMPARISON_FIELDS_SERVER_SUCCESS'
export const AI_COMPARISON_DATA_SUCCESS = 'AI_COMPARISON_DATA_SUCCESS';
export const AI_COMPARISON_FIELDS_DROPDOWN_SUCCESS = 'AI_COMPARISON_FIELDS_DROPDOWN_SUCCESS';
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

const aiComparisonFieldsRequest = () => ({
  type: AI_COMPARISON_FIELDS_REQUEST,
})

export const aiComparisonFieldsServerListSuccess = () => ({
  type: AI_COMPARISON_FIELDS_SERVER_SUCCESS
})

const aiComparisonFieldsListSuccess = aiComparisonFieldsList => ({
  type: AI_COMPARISON_FIELDS_SUCCESS,
  aiComparisonFieldsList: aiComparisonFieldsList,
})

const aiComparisonFieldsFailure = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'general_error'
})
const validationError = notification => ({
  type: AI_COMPARISON_FIELDS_VALIDATION_ERROR,
  validation_error: notification,
})
const tokenError = notification => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: notification,
  snackbar_notification_type: 'token_expire'
})

const aiComparisonFieldsAddUpadteSuccess = (message, action, dispatch) => {
  dispatch(aiComparisonFieldsSuccessNotification(message))
  dispatch(redirectToAIComparisonFieldsList())
}

export const redirectToAIComparisonFieldsList = () => ({
  type: REDIRECT_TO_AI_COMPARISON_FIELDS_LIST,
})

const getAIComparisonFieldsSuccess = (response, action) => ({
  type: AI_COMPARISON_FIELDS_GET_SUCCESS,
  record: response,
  actionType: action
})

const aiComparisonFieldsSuccessNotification = message => ({
  type: SHOW_SNACKBAR,
  snackbar_notification: message,
  snackbar_notification_type: 'success'
})


export const hideAIComparisonFieldsValidationError = (feild_key) => ({
  type: HIDE_AI_COMPARISON_FIELDS_FEILD_VALIDATION_ERROR,
  feild_key: feild_key
})

/*
 * AI Comparison Fields dropdown list fetch methods
*/
const aiComparisonFieldsDropdownSuccess = aiComparisonFieldsDropdownList => ({
  type: AI_COMPARISON_FIELDS_DROPDOWN_SUCCESS,
  aiComparisonFieldsDropdownList: aiComparisonFieldsDropdownList,
})

export const aiComparisonFieldsDropdownFetch = (client_ids, list_ids, object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonFieldsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonFields/getAllForDropdown", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        client_ids: client_ids,
        list_ids: list_ids,
        object_viewed_id: object_viewed_id
      }
    })
    .then((response) => {
      dispatch(aiComparisonFieldsDropdownSuccess(response.data))
      dispatch(hideCommonLoader())
    }, (error) => {
      handleErrorResponse(error, dispatch)
      dispatch(hideCommonLoader())
    });

  }
}

export const aiComparisonFieldsListFetch = (object_viewed_id = '') => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonFieldsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonFields/getAll", {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      params: {object_viewed_id: object_viewed_id}
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(aiComparisonFieldsListSuccess(response.data))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const addAIComparisonFields = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonFieldsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonFields/create", {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: data,
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        aiComparisonFieldsAddUpadteSuccess('AI Comparison Fields Added Successfully', 'create', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const updateAIComparisonFields = (data) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonFieldsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonFields/update/" + data.id, {
      method: "PUT",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
      data: data
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        aiComparisonFieldsAddUpadteSuccess('AI Comparison Fields Updated Successfully', 'update', dispatch)
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const getAIComparisonFieldsById = (id, action) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonFieldsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonFields/getById/" + id, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer  ' + token
      },
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(getAIComparisonFieldsSuccess(response.data, action))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });

  }
}

export const deleteAIComparisonFields = (aiComparisonFieldsId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonFieldsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparisonFields/delete/" + aiComparisonFieldsId, {
      method: "DELETE",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data: {
        object_viewed_id
      }
    })
      .then((response) => {
        dispatch(hideCommonLoader())
        dispatch(aiComparisonFieldsSuccessNotification('AI Comparison Fields deleted successfully'))
      }, (error) => {
        dispatch(hideCommonLoader())
        handleErrorResponse(error, dispatch)
      });
  }

}

const aiComparisonDataSuccess = aiComparisonData => ({
  type: AI_COMPARISON_DATA_SUCCESS,
  aiComparisonData: aiComparisonData,
})

export const getComparisonDataByClient = (clientId, listId, fieldGroupId, object_viewed_id) => {
  var token = localStorage.getItem("token")
  return dispatch => {
    dispatch(aiComparisonFieldsRequest())
    dispatch(showCommonLoader())
    return axios(API_URL + "aiComparison/"+clientId, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'Authorization': 'Bearer ' + token
      },
      data:  {
        object_viewed_id: object_viewed_id,
        listId: listId,
        fieldGroupId: fieldGroupId
      }
    })
    .then((response) => {
      dispatch(hideCommonLoader())
      dispatch(aiComparisonDataSuccess(response.data))
    }, (error) => {
      dispatch(hideCommonLoader())
      handleErrorResponse(error, dispatch)
    });

  }
}

// handling error reponse   
const handleErrorResponse = (error, dispatch) => {
  try {
    if (error.response.status === 422 && error.response.data.error) {
      dispatch(validationError(error.response.data.error))
    }
    else if (error.response.status === 401 && error.response.data.error) {
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else {
      let err = '';
      if (error.response.data.error) {
        err = error.response.data.error.toString()
      }
      else {
        err = error.response.status + ` ` + error.response.statusText
      }
      dispatch(aiComparisonFieldsFailure(err))
    }
  }
  catch (e) {
    dispatch(aiComparisonFieldsFailure('Unable to perform action.Something went wrong'))
  }
}   